//https://markoskon.com/extremely-fast-load-time-with-gatsby-and-self-hosted-fonts/#updates
require("typeface-marcellus");
require("typeface-lato");
